/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import React, { Component } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import redirectURL from '../redirectURL';
var moment = require('moment');

// ePOD Activity Log ("View Logs") - read-only slide-out panel, same open/close/slide-in mechanics
// as the existing ReviewPodSlider (reused deliberately, not a new pattern). Calls the new
// read-only /billing/epodActivityLog endpoint, which itself only NORMALIZES/aggregates activity
// already recorded by the existing dealer confirmation / AL review / revert / late-upload
// services - this component and that endpoint never change any workflow state, upload/delete any
// document, or trigger any notification.
//
// UI note: the log table is rendered with the SAME AG Grid setup already used by
// alReviewScreen.js/epodScreen.js (@ag-grid-community/react + AllModules, ag-theme-balham,
// defaultColDef={resizable,sortable,filter}) instead of a plain HTML table, purely for layout/
// sort/filter quality - the fetch/loading/error/empty logic below is otherwise unchanged.
//
// props:
//   row     - the clicked grid row (needs gc_waybill_no)
//   onClose - () => void
class ViewLogsSlider extends Component {
    state = {
        entered: false,
        loading: true,
        error: '',
        rows: [],
    };

    componentDidMount() {
        requestAnimationFrame(() => { this.setState({ entered: true }); });
        this.loadLogs();
    }

    loadLogs = () => {
        var row = this.props.row;
        if (!row || !row.gc_waybill_no) {
            this.setState({ loading: false, error: 'No LR selected.' });
            return;
        }
        this.setState({ loading: true, error: '' });
        redirectURL.post("/billing/epodActivityLog",
            { gc_waybill_no: row.gc_waybill_no },
            { headers: { 'Authorization': localStorage.getItem("userid") } })
            .then((resp) => {
                var ok = resp.data && resp.data.status === "success";
                if (ok) {
                    this.setState({ loading: false, rows: resp.data.rows || [] });
                } else {
                    this.setState({ loading: false, error: (resp.data && resp.data.message) || 'Failed to load activity log.' });
                }
            })
            .catch((err) => {
                this.setState({ loading: false, error: (err.response && err.response.data && err.response.data.message) || 'Failed to load activity log.' });
            });
    }

    // Same "key: value, key: value" flattening the previous plain-table version used - unchanged,
    // just now feeds a grid cell's value instead of JSX directly, so it sorts/filters like any
    // other text column for free.
    formatDetails = (details) => {
        if (!details || typeof details !== 'object') return '-';
        var keys = Object.keys(details).filter((k) => details[k] !== null && details[k] !== undefined && details[k] !== '');
        if (keys.length === 0) return '-';
        return keys.map((k) => k.replace(/_/g, ' ') + ': ' + details[k]).join(', ');
    }

    // ---- Time column ---------------------------------------------------------------------------
    // valueGetter returns a REAL Date (or null) - this is the value AG Grid actually sorts/filters
    // on. valueFormatter controls ONLY the displayed text (DD-MM-YYYY HH:mm, same convention
    // epodScreen.js's own "Reverted At" column already uses via moment) - the two are deliberately
    // separate so formatting the display never weakens sorting/filtering to string comparison.
    timeValueGetter = (params) => {
        var raw = params.data && params.data.timestamp;
        if (!raw) return null;
        var d = new Date(raw);
        return isNaN(d.getTime()) ? null : d;
    }
    timeValueFormatter = (params) => {
        return params.value ? moment(params.value).format('DD-MM-YYYY HH:mm') : '-';
    }
    // Row sort comparator - full precision (not just day-granularity), so two actions on the same
    // day still sort correctly by exact time.
    timeSortComparator = (a, b) => {
        var at = a ? a.getTime() : 0;
        var bt = b ? b.getTime() : 0;
        return at - bt;
    }
    // agDateColumnFilter's own comparator - compares the filter's picked day (midnight-local)
    // against the cell's real Date, at day granularity, exactly how AG Grid's date filter is
    // documented to work (equals/notEqual/lessThan/greaterThan/inRange all derive from this).
    timeFilterComparator = (filterLocalDateAtMidnight, cellValue) => {
        if (!cellValue) return -1;
        var cellDate = new Date(cellValue.getFullYear(), cellValue.getMonth(), cellValue.getDate());
        if (cellDate.getTime() === filterLocalDateAtMidnight.getTime()) return 0;
        return cellDate < filterLocalDateAtMidnight ? -1 : 1;
    }

    getColumnDefs = () => [
        {
            headerName: "Date & Time",
            field: "timestamp",
            width: 180,
            sort: 'desc', // Activity Log default: newest first (API already returns newest-first; this keeps the grid's own sort state consistent with that)
            valueGetter: this.timeValueGetter,
            valueFormatter: this.timeValueFormatter,
            comparator: this.timeSortComparator,
            filter: "agDateColumnFilter",
            filterParams: {
                browserDatePicker: true,
                comparator: this.timeFilterComparator,
            },
        },
        {
            headerName: "Action",
            field: "action",
            width: 200,
            valueGetter: (params) => (params.data && params.data.action) || '-',
        },
        {
            headerName: "Performed By",
            field: "performed_by",
            width: 170,
            valueGetter: (params) => (params.data && params.data.performed_by) || '-',
        },
        {
            headerName: "Email",
            field: "email",
            width: 230,
            valueGetter: (params) => (params.data && params.data.email) || '-',
        },
        {
            headerName: "Role",
            field: "role",
            width: 150,
            valueGetter: (params) => (params.data && params.data.role) || '-',
        },
        {
            headerName: "Remarks",
            field: "remarks",
            width: 260,
            tooltipValueGetter: (params) => params.value !== '-' ? params.value : null,
            valueGetter: (params) => (params.data && params.data.remarks) || '-',
        },
        {
            headerName: "Details",
            field: "details",
            width: 280,
            tooltipValueGetter: (params) => params.value !== '-' ? params.value : null,
            valueGetter: (params) => this.formatDetails(params.data && params.data.details),
        },
    ];

    render() {
        var row = this.props.row;
        var { entered, loading, error, rows } = this.state;

        return (
            <div>
                {/* Backdrop */}
                <div onClick={this.props.onClose} style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1040,
                    background: 'rgba(0,0,0,0.5)', opacity: entered ? 1 : 0, transition: 'opacity 0.25s ease',
                }} />
                {/* Panel */}
                <div style={{
                    position: 'fixed', top: 0, right: 0, bottom: 0, width: '1100px', maxWidth: '95vw',
                    background: '#fff', zIndex: 1050, boxShadow: '-2px 0 12px rgba(0,0,0,0.25)',
                    transform: entered ? 'translateX(0)' : 'translateX(100%)', transition: 'transform 0.28s ease',
                    display: 'flex', flexDirection: 'column',
                }}>
                    <div style={{ padding: '14px 18px', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: '0 0 auto' }}>
                        <h5 style={{ margin: 0 }}>Activity Log{row && row.gc_waybill_no ? ' - ' + row.gc_waybill_no : ''}</h5>
                        <button className="btn btn-sm btn-outline-secondary" onClick={this.props.onClose}>Close</button>
                    </div>

                    {/* flex:1 + minHeight:0 is what lets the grid below actually fill the rest of
                        the panel instead of only taking the height its content needs (the old
                        plain-table version's whitespace problem) - the panel is position:fixed
                        top:0/bottom:0, so this flex chain has a real height to distribute. */}
                    <div style={{ padding: '16px 18px', flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                        {loading ?
                            <div className="text-center" style={{ padding: '30px 0' }}>Loading activity log...</div>
                            : error ?
                                <div className="alert alert-danger">{error}</div>
                                : rows.length === 0 ?
                                    <div className="text-center text-muted" style={{ padding: '30px 0' }}>No activity found for this e-POD.</div>
                                    :
                                    <div className="ag-theme-balham" style={{ width: '100%', flex: '1 1 auto', minHeight: 0 }}>
                                        <AgGridReact
                                            modules={AllModules}
                                            columnDefs={this.getColumnDefs()}
                                            rowData={rows}
                                            defaultColDef={{ resizable: true, sortable: true, filter: true }}
                                            enableBrowserTooltips={true}
                                        />
                                    </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default ViewLogsSlider;
